import React, { useState } from 'react';
import Nav           from './components/Nav';
import Hero          from './components/Hero';
import About         from './components/About';
import Mission       from './components/Mission';
import Services      from './components/Services';
import Scrip         from './components/Scrip';
import ScripRegister from './components/ScripRegister';
import Contact       from './components/Contact';
import Footer        from './components/Footer';

export default function App() {
  const [showRegister, setShowRegister] = useState(false);

  return (
    <>
      <Nav onRegister={() => setShowRegister(true)} />
      <main>
        <Hero     onRegister={() => setShowRegister(true)} />
        <About    />
        <hr className="divider" />
        <Mission  />
        <hr className="divider" style={{ background: 'rgba(212,175,55,0.1)' }} />
        <Services />
        <Scrip    onRegister={() => setShowRegister(true)} />
        <Contact  />
      </main>
      <Footer />

      {showRegister && (
        <ScripRegister onClose={() => setShowRegister(false)} />
      )}
    </>
  );
}